import React, { useContext, useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Userfeed } from '../../components/UserFeed/Userfeed';
import client from '../../API/client';
import { Box, Button, CircularProgress, Input, Paper, TextField } from '@mui/material';
import Colors from '../../Constant/Colors';
import './Designer.css';
import moment from 'moment/moment';
import { AuthContext, UserContextData } from '../../context/AuthContext';
import AddPhotoAlternateOutlinedIcon from '@mui/icons-material/AddAPhotoOutlined';
import AWS from 'aws-sdk';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Backdrop from '@mui/material/Backdrop';
import upload from '../../assets/Json/folder-upload.json';
import Lottie from 'lottie-react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
// import CircularProgress from '@mui/material/CircularProgress';

export const DesignerdashboardContent = () => {
  const [postdata, setPostData] = useState([]);
  const [desc, setDesc] = useState('');
  const [imguri, setImg] = useState('');
  const [suggested, setSuggested] = useState([]);
  const [isloading, setIsLoading] = React.useState(false);
  const [postload,setpostLoad] = useState(false);
  var createdAt = moment(Date.now()).format('YYYY-MM-DD HH:mm:ss');
  const { Designer } = useContext(UserContextData);
  const id = localStorage.getItem('user_id');

  const getPost = async () => {
    setpostLoad(true);
    try {
      const result = await client
        .get(`/feed`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(async (res) => {
          setPostData(res.data);
          // console.log(res.data)
          setpostLoad(false);
        });
    } catch (error) {}
    try {
      await client.get('/user/suggested-for-you').then((res) => {
        setSuggested(res.data);
      });
    } catch (error) {}
  };

  const rmImage = () => {
    setImg('');
  };

  useEffect(() => {
    getPost();
  }, []);

  const handleImage = (e) => {
    setImg(e.target.files[0]);
    console.log('File', e.target.files[0]);
  };

  const s3 = new AWS.S3({
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_AWS_SECRETE_ACCESS_KEY,
    region: process.env.REACT_APP_REGION,
  });

  async function handleFileUpload(file) {
    setIsLoading(true);
    const params = {
      Bucket: process.env.REACT_APP_BUCKET,
      Key: file.name,
      Body: file,
    };

    try {
      if (file) {
        const response = await s3.upload(params).promise();
        const locationLink = response.Location;
        client
          .post(`/upload-post`, {
            id,
            locationLink,
            desc,
            createdAt,
          })
          .then((res) => {
            if (res.status === 200) {
              toast.success('Post uploaded succesfully !', {
                position: toast.POSITION.TOP_CENTER,
              });
              setIsLoading(false);
              getPost();
              setImg('');
              setDesc('');
            } else {
              toast.error('OOps!! Something went wrong ', {
                position: toast.POSITION.TOP_CENTER,
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        const locationLink = null;
        client
          .post(`/upload-post`, {
            id,
            locationLink,
            desc,
            createdAt,
          })
          .then((res) => {
            if (res.status === 200) {
              toast.success('Post uploaded succesfully !', {
                position: toast.POSITION.TOP_CENTER,
              });
              setIsLoading(false);
              getPost();
              setImg('');
              setDesc('');
            } else {
              toast.error('OOps!! Something went wrong ', {
                position: toast.POSITION.TOP_CENTER,
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    } catch (error) {
      toast.error('Oops!! Something went wrong', {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  }
  return (
    <>
      <Container fluid style={{ backgroundColor: 'whitesmoke' }}>
        {isloading && (
          <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open>
            <Lottie animationData={upload} loop={true} className="Imganimation " style={{ width: 300 }} />
          </Backdrop>
        )}
        <ToastContainer />
        <Row>
          <Col xs={7}>
            
            <div
              style={{
                height: '760px',
                overflow: 'scroll',
                backgroundColor: 'whitesmoke',
              }}>
                <div style={{alignItems:"center",justifyContent:"center",display:"flex",fontSize:"20px",marginTop:"20px"}}>{postload ?  <CircularProgress/> : ''}</div>
              {postdata.map((data)=>(
                <Userfeed props={data} />
              ))}
            </div>
          </Col>
          <Col xs={5}>
            <Box mt="20px" backgroundColor="whitesmoke">
              <Paper elevation={4} sx={{ padding: '20px' }}>
                <div style={{ marginBottom: '10px' }}>
                  <h4>Upload Post </h4>
                </div>

                <TextField
                  label="Post Description"
                  name="description"
                  variant="outlined"
                  multiline={true}
                  onChange={(e) => setDesc(e.target.value)}
                  rows={2}
                  style={{
                    width: '100%',
                    marginBottom: '8px',
                  }}
                />
                {imguri && (
                  <img
                    src={URL.createObjectURL(imguri)}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />
                )}
                {/* <div>
                  <span style={{ fontSize: '15px', color: Colors.primary }}>Add Image</span>
                </div> */}
                <div>
                  <div style={{ marginTop: '10px' }}>
                    <div>
                      <Input id="Imageinput" type="file" hidden placeholder="Add Image" accept="image/png, image/jpeg" onChange={handleImage} />
                      <Button as="label" htmlFor="Imageinput" variant="outlined">
                        <AddPhotoAlternateOutlinedIcon style={{ marginRight: 8 }} />
                        Choose Image
                      </Button>
                      {imguri ? (
                        <Button variant="outlined" sx={{ marginLeft: '10px' }} onClick={() => rmImage()}>
                          delete
                        </Button>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                </div>
                <div style={{ marginTop: '10px' }}>
                  <Button
                    onClick={() => handleFileUpload(imguri)}
                    variant="contained"
                    type="submit"
                    style={{
                      width: '100%',
                      backgroundColor: Colors.secondary,
                      color: Colors.primary,
                    }}>
                    Upload
                  </Button>
                </div>
              </Paper>
            </Box>
            <Row>
              <Box mt="20px" backgroundColor="whitesmoke">
                <Paper elevation={4} sx={{ padding: '20px' }}>
                  <div>
                    <h4>Suggested for you</h4>
                  </div>
                  <Box
                    style={{
                      height: '390px',
                      overflow: 'scroll',
                    }}>
                    {suggested.map((data) => (
                      <List sx={{ width: '100%', maxWidth: '100%', bgcolor: 'background.paper' }}>
                        <ListItem alignItems="flex-start">
                          <ListItemAvatar>
                            <Avatar alt={data.user_name} src="/static/images/avatar/1.jpg" />
                          </ListItemAvatar>
                          <ListItemText
                            onClick={() => console.log('Cliecks')}
                            primary={data.user_name}
                            secondary={
                              <React.Fragment>
                                <Typography sx={{ display: 'inline' }} component="span" variant="body2" color="text.primary">
                                  {data.user_role}
                                </Typography>
                              </React.Fragment>
                            }
                          />
                        </ListItem>
                        <Divider variant="inset" component="li" />
                      </List>
                    ))}
                  </Box>
                </Paper>
              </Box>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
};
